(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {
        	'save': {
        		method: 'POST', 
        		isArray: false,
        		transformResponse: function (data, headers, status) {
        			if (status == 200) {
        				return {data: data};
        			}
                    return data;
                }
        	}
        });

        return service;
    }
})();
